var exports = {
  "kL": "x61f99309--f0f083--container",
  "n1": "x61f99309--f0f083--circle",
  "wG": "x61f99309--f0f083--loader",
  "uW": "x61f99309--f0f083--circle-spin",
  "Ri": "x61f99309--f0f083--incoming",
  "x6": "x61f99309--f0f083--button",
};

module.exports = exports;
